<template>
  <NuxtLayout name="minimal">
    <div id="page_not_found">
      <div class="image"></div>
      <h1>
        {{ $t("page_not_found.title") }}
      </h1>
      <h2>
        {{ $t("page_not_found.subtitle") }}
      </h2>
      <router-link class="btn" :to="{ name: 'home' }">
        {{ $t("page_not_found.buttons.home") }}
      </router-link>
    </div>
  </NuxtLayout>
</template>

<style scoped lang="scss">
@import "@/assets/scss/variables";
@import "@/assets/scss/classes";

#page_not_found {
  text-align: center;

  .btn {
    @extend %fresh-btn;
  }

  .image {
    display: blocK;
    margin: auto;
    height: 300px;
    background-image: url("/img/subscribe_girl.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
}
</style>
